(function () {

  'use strict';

  angular.module('UserProperties')

    .constant('USER_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-pin',
        section: 'sites',
        caption: 'ManagedSites',
        selected: false,
        show: false
      },
      {
        icon: 'icon-group',
        section: 'groups',
        caption: 'Groups',
        selected: false,
        show: false
      },
      {
        icon: 'icon-history',
        section: 'history',
        caption: 'History',
        selected: false,
        show: true
      }
    ])

    .controller('UserPropertiesController', function (
      $rootScope, $scope, $filter, $location, URLS, UserListService, toastr,
      $routeParams, URL_PARAMS, GroupListService, TenantListService, USER_RIGHTS, USER_ROLES,
      GroupListPaging, USER_PROPERTIES_TABS, EventHandlerService, $window,
      WorkstationModel, SitesProviderService, EventServiceEvents, $timeout) {

      $scope.user = null;
      $scope.userOriginal = null;
      $scope.USER_RIGHTS = USER_RIGHTS;
      $scope.USER_ROLES = USER_ROLES;
      $scope.userPropertiesForm = {};
      $scope.sites = null;
      $scope.loadingSites = false;
      $scope.workstations = [];
      $scope.searchInputPlaceholderText = 'SearchGroupByNameAndDescription';
      $scope.groupListPaging = new GroupListPaging();
      $scope.groupListPaging.pagingCriteria.inUse = true;
      $scope.groupListPaging.pagingCriteria.userFilterMode = 'PRESENT';
      $scope.noDataMessage = 'NoGroups';
      $scope.me = null;

      (function () {
        EventHandlerService.deRegisterListeners();
      })();

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.setSection = function (section) {
        $scope.showSection = section;
        const url = $location.path();
        $location.path(url, false).search({ userSection: section });
      };

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        if ($scope.showSection) {
          switch ($scope.showSection) {
            case 'setup':
              $scope.helpCaption = 'HelpUserPropertiesSetup';
              break;
            case 'sites':
              $scope.helpCaption = 'HelpUserPropertiesSites';
              break;
            case 'groups':
              $scope.helpCaption = 'HelpUserPropertiesGroups';
              break;
            case 'history':
              $scope.helpCaption = 'HelpUserPropertiesHistory';
              break;
          }
        }
      }, true);

      $scope.isSystemManager = function () {
        return $scope.user && $scope.user.info._embedded.permissions.role === USER_ROLES.SYSTEM_MANAGER;
      };

      $scope.isSystemObserver = function () {
        return $scope.user && $scope.user.info._embedded.permissions.role === USER_ROLES.SYSTEM_OBSERVER;
      };

      $scope.isGuestUser = function () {
        return $scope.user && $scope.user.info._embedded.permissions.role === USER_ROLES.GUEST_USER;
      };

      $scope.isKioskUser = function () {
        return $scope.user && $scope.user.info._embedded.permissions.role === USER_ROLES.KIOSK_USER;
      };

      $scope.isSiteManager = function () {
        return $scope.user && $scope.user.info._embedded.permissions.roles.includes('SITE_MANAGER');
      };

      $scope.hasPrintJobCreatePermission = function () {
        return $scope.user && $scope.user.info._embedded.permissions.permissions.includes(USER_RIGHTS.RESOURCE_PRINTJOB_CREATE);
      };

      (function () {
        if ($routeParams.userSection) {
          $scope.showSection = $routeParams.userSection;
        } else {
          $scope.showSection = 'setup';
        }
      })();

      function calibrateTabs() {
        setGroupsTabEnabledState();
        $scope.tabs = USER_PROPERTIES_TABS;
      }

      function setGroupsTabEnabledState() {
        USER_PROPERTIES_TABS.find(tab => tab.section === 'groups').show = TenantListService.currentTenant.info.groupsEnabled && !TenantListService.currentTenant.isPowerPDFOnly();
      }

      function setSitesTabEnabledState() {
        USER_PROPERTIES_TABS.find(tab => tab.section === 'sites').show = $scope.isSiteManager();
      }

      $scope.getFirstPageOfGroups = function () {
        if (TenantListService.currentTenant && TenantListService.currentTenant.info && $scope.userOriginal) {
          $scope.groupListPaging.pagingCriteria.page = 0;
          $scope.groupListPaging.pagingCriteria.pageSize = 5;
          $scope.groupsLoading = true;
          GroupListService.getGroupListPaged($scope.groupListPaging)
            .then(function (groupContainer) {
              $scope.groupList = groupContainer;
              $scope.groupsLoading = false;
            })
            .catch(function () {
              $scope.groupsLoading = false;
            });
        } else {
          const deregister = $scope.$watch(function () {
            return TenantListService.currentTenant;
          }, function () {
            if (TenantListService.currentTenant && TenantListService.currentTenant.info) {
              deregister();
              $scope.getFirstPageOfGroups();
            }
          }, true);
        }
      };

      $scope.getNextPageOfGroups = function () {
        $scope.groupListPaging.pagingCriteria.page += 1;
        getPageOfGroups();
      };

      $scope.getPreviousPageOfGroups = function () {
        $scope.groupListPaging.pagingCriteria.page -= 1;
        getPageOfGroups();
      };

      function getPageOfGroups() {
        $scope.groupsLoading = true;
        GroupListService.getGroupListPaged($scope.groupListPaging)
          .then(function (groupContainer) {
            $scope.groupList = groupContainer;
            $scope.groupsLoading = false;
          })
          .catch(function () {
            $scope.groupsLoading = false;
          });
      }

      $scope.saveChanges = function (form, $event) {
        if (form && $event) {
          if (form.$invalid) {
            $event.preventDefault();
          } else {
            setNotificationOptions();
            $scope.waitingForAnswer = true;
            $scope.userOriginal.saveChanges($scope.user)
              .then(function (response) {
                $scope.waitingForAnswer = false;
                form.$setPristine();
                let message = '';
                if (response && response.data) {
                  message = $filter('translate')('ChangesSaved');
                } else {
                  message = $filter('translate')('NoChangesMade');
                }
                toastr.success(message);
                $location.path(URLS.USER_LIST);
              })
              .catch(function () {
                $scope.waitingForAnswer = false;
              });
          }
        }
      };

      function setNotificationOptions() {
        $scope.user.info.emailOptOuts = [];
        if (!$scope.notificationSettings.dataBreach) {
          $scope.user.info.emailOptOuts.push('DATABREACH');
        }
        if (!$scope.notificationSettings.updatedLegalDocuments) {
          $scope.user.info.emailOptOuts.push('LEGAL');
        }
      }

      function notificationOptions(user) {
        $scope.notificationSettings = {
          dataBreach: !user.info.emailOptOuts.includes('DATABREACH'),
          updatedLegalDocuments: !user.info.emailOptOuts.includes('LEGAL')
        };
      }

      $scope.initUser = function () {
        UserListService.getUserById($routeParams[URL_PARAMS.USER_ID.ROUTE])
          .then(function (user) {
            if (user && !user.info.expires) {
              $scope.groupListPaging.pagingCriteria.user = user.info._links.self.href;
              $scope.userOriginal = user;
              $scope.getFirstPageOfGroups();
              notificationOptions(user);
              $scope.user = angular.copy(user);
              $scope.user.getLoggedInWorkstations()
                .then(function (workstations) {
                  if (workstations) {
                    $scope.workstations = workstations.map(workstation => new WorkstationModel(workstation));
                  }
                })
                .catch(function () {
                });

              if (user.info._embedded.permissions.roles.includes('SITE_MANAGER')) {
                getSiteTree();
              }
              if (!$scope.hasPrintJobCreatePermission()) {
                $scope.showSection = 'history';
              }
              $rootScope.secondaryHeadline = $scope.user.info._embedded.user.name;
              if ($routeParams[URL_PARAMS.SHOW_USER_SECTION.ROUTE]) {
                $scope.showSection = $routeParams[URL_PARAMS.SHOW_USER_SECTION.ROUTE];
              } else {
                $scope.showSection = 'setup';
              }
              setSitesTabEnabledState();
            } else {
              $location.path(URLS.USER_LIST);
            }
          })
          .catch(function () {
          });
      };

      function getSiteTree() {
        $scope.loadingSites = true;
        SitesProviderService.getSitesAllSites().then(function (response) {
          const sites = {
            root: angular.copy(response.tree.siteTreeFolders)
          };
          removeSitesNotManagedByCurrentUser(sites.root);
          $scope.sites = sites;
          $scope.loadingSites = false;
        }).catch(function () {
          $scope.loadingSites = false;
        });
      }

      function removeSitesNotManagedByCurrentUser(children) {
        const userGroupIds = getUserGroupIds($scope.user);
        removeSitesRecursively(children, userGroupIds, false);
      }

      function removeSitesRecursively(children, userGroupIds, isManagedByFolder) {
        for (let i = children.length - 1; i >= 0; --i) {
          const item = children[i];
          if (item.type === 'folder') {
            const isManagedByUser = isUserInAnySiteManagerGroup(userGroupIds, item);
            if (isManagedByUser) {
              item.isManagedByUser = true; // used to display directly managed folders in bold
            }
            removeSitesRecursively(item.children, userGroupIds, isManagedByFolder || isManagedByUser);
            if (item.children.length === 0) {
              children.splice(i, 1); // remove folders without any content
            } else {
              item.open = true; // start with all folders in open state
            }
          } else if (item.type === 'file') {
            if (isUserInAnySiteManagerGroup(userGroupIds, item)) {
              item.isManagedByUser = true; // used to display directly managed sites in bold
            } else if (!isManagedByFolder) {
              children.splice(i, 1); // remove unmanaged sites
            }
          }
        }
      }

      function getUserGroupIds(user) {
        if (user.info._embedded.groups) {
          return user.info._embedded.groups.map(group => {
            const urlParts = group._links.self.href.split('/');
            return urlParts[urlParts.length - 1];
          });
        } else {
          return [];
        }
      }

      function getSiteGroupIds(site) {
        return site.siteAdminGroup.map(group => {
          const urlParts = group.href.split('/');
          return urlParts[urlParts.length - 1];
        });
      }

      function isUserInAnySiteManagerGroup(userGroupIds, site) {
        const siteGroupIds = getSiteGroupIds(site);
        return userGroupIds.some(id => siteGroupIds.includes(id));
      }

      $scope.gotoSite = function (siteId) {
        const target = $location.absUrl().split('userProperties/');
        $window.open(target[0] + 'sites/' + siteId, '_blank');
      };

      $scope.toggleFolder = function (folder) {
        folder.open = !folder.open;
      };

      $scope.$watch(function () {
        return TenantListService.currentTenant;
      }, function () {
        if (TenantListService.currentTenant) {
          calibrateTabs();
        }
      }, true);

      if ($routeParams[URL_PARAMS.USER_ID.ROUTE]) {
        $scope.initUser();
      } else {
        $location.path(URLS.USER_LIST);
      }

      let taskGroupId = null;

      $scope.synchronizeGroups = function () {
        toastr.success($filter('translate')('GroupsSynchronizationStarted'));
        $scope.ongoingGroupSync = true;
        $scope.user.synchronizeGroups()
          .then(function (response) {
            taskGroupId = response.data.taskId;
          })
          .catch(function () {
          });
      };

      const deregisterGroupsSynchronizationCompleteListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.GROUPS_SYNCHRONIZATION_COMPLETE, function (event, data) {
        if (taskGroupId === data.taskGroupId) {
          if (data.status === 'COMPLETED') {
            taskGroupId = null;
            $scope.getFirstPageOfGroups();
            $timeout(() => {
              toastr.success($filter('translate')('GroupsSynchronizationDone'));
              $scope.ongoingGroupSync = false;
            }, 2500);
          } else {
            $scope.ongoingGroupSync = false;
          }
        }
      });

      $scope.$on('$destroy', function () {
        deregisterGroupsSynchronizationCompleteListener();
      });

    });

})();
